import styled from 'styled-components'

export const LineChartWrapper = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`
